import { connect } from 'react-redux';
import { doNotShowAgainChanged } from '../../Modals/redux/actionCreators';
import { CompliantLocalStorageKeys } from '../../redux/compliantLocalStorage/constants';
import { getCompliantLocalStorageItem } from '../../redux/compliantLocalStorage/selectors';
export var mapStateToProps = function (state, ownProps) {
    var dnsDb = getCompliantLocalStorageItem(state, CompliantLocalStorageKeys.DO_NOT_SHOW_AGAIN);
    var autoAccept = false;
    if (dnsDb) {
        try {
            var dnsItems = JSON.parse(dnsDb);
            autoAccept = dnsItems[ownProps.doNotShowAgainKey || ''];
        }
        catch (e) { }
    }
    return {
        autoAcceptForDoNotShow: autoAccept,
    };
};
export var mapDispatchToProps = function (dispatch, props) { return ({
    onDoNotShowAgainChange: function (key, value) {
        return dispatch(doNotShowAgainChanged(key, value));
    },
}); };
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=ConfirmationModal.container.js.map